export function isValidateRequired(value: string, required: boolean): boolean {
  if (required) {
    return !!value;
  }
  return true;
}

export function isValidateRequiredFile(file: any, required: boolean): boolean {
  if (required) {
    if (file !== undefined) {
      if (file.length === undefined) { //length取得出来ない＝ファイルが選ばれている
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  return true;
}

export function isValidate(value: string, maxlength: string, minlength: string, patternString: string): boolean {
  if (value) {
    if (maxlength && value.length > Number(maxlength)) {
      return false;
    }
    if (minlength && value.length < Number(minlength)) {
      return false;
    }
    // 正規表現チェック
    if (patternString) {
      const pattern = new RegExp(patternString);
      if (!pattern.test(value)) {
        return false;
      }
    }
  }
  return true;
}

export function isValidateNumber(value: string, min: string, max: string, decimalDigits: string): boolean {
  if (value) {
    if (max && Number(value) > Number(max)) {
      return false;
    }
    if (min && Number(value) < Number(min)) {
      return false;
    }
    // 小数チェック
    if (decimalDigits) {
      if (Number(decimalDigits) < 0) {
        // マイナスはダメ
        return false;
      }
      const numbers = value.split('.');
      if ((Number(decimalDigits) === 0) && (numbers.length !== 1)) {
        // 小数点以下不要
        return false;
      }
      // 小数点以下入力可
      if (numbers.length === 2) {
        // '.'が1つ
        if (Number(numbers[1].length) > 0) {
          if (Number(numbers[1].length) > Number(decimalDigits)) {
            return false;
          }
        } else {
          return false;
        }
      } else if (numbers.length > 2) {
        return false;
      }
    }
  }
  return true;
}
